import React, { useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import Comments from "./Comments";

const FormRadioButton = ({
  name,
  label,
  subLabel,
  options,
  error,
  onChange,
  className,
  disabled,
  value,
  commentsFactory,
  ref,
  divClassName,
  labelClassName,
  subLabelClassName,
  optionsOnNewLine,
  optionsMarginClassName,
  optionsDivClassName,
  labelStyle,
  optionsLabelStyle,
  ...rest
}) => {
  const [showComments, setShowComments] = useState(false);

  const toggleComments = () => {
    setShowComments(!showComments);
  };

  const comments = commentsFactory?.get(name);

  return (
    <>
      {comments && showComments ? (
        <Comments comments={comments} commentsFactory={commentsFactory} />
      ) : null}
      <div
        className={`form-group mb-3${divClassName ? ` ${divClassName}` : ""}`}
        {...rest}
      >
        {label && (
          <>
            <label
              className={`form-label${
                labelClassName ? ` ${labelClassName}` : ""
              }`}
              style={labelStyle}
            >
              {label}
              {comments?.length > 0 ? (
                <i
                  className="fas fa-comment-alt text-warning m-2"
                  onClick={toggleComments}
                />
              ) : null}
            </label>
            <br />
          </>
        )}
        {subLabel ? (
          <>
            <label
              htmlFor={name}
              className={`form-label ${subLabelClassName || "fst-italic"}`}
            >
              {subLabel}
            </label>
            <br />
          </>
        ) : null}
        <span>
          {options?.map((option, index) => (
            <React.Fragment key={`options.${index}.${option._id}`}>
              <div
                className={`form-check${
                  !optionsOnNewLine ? " form-check-inline" : ""
                }${optionsDivClassName ? ` ${optionsDivClassName}` : ""}`}
              >
                <span>
                  <input
                    className={`form-check-input border-secondary ${
                      optionsMarginClassName ? optionsMarginClassName : "mx-2"
                    } rbutton ${className ? ` ${className}` : ""}`}
                    type="radio"
                    name={name}
                    value={option._id}
                    checked={option._id === value}
                    onChange={onChange}
                    disabled={disabled}
                    ref={ref}
                    style={{
                      border: "1px solid rgba(0, 0, 0, .25) !important",
                    }}
                  />
                  <span
                    className={`d-none d-print-inline ${
                      option._id === value ? "checked" : "not-checked"
                    }`}
                  />
                </span>
                {option.name ? (
                  <span className="flex-fill">
                    <label
                      className="d-print-none form-check-label"
                      htmlFor={name}
                      style={optionsLabelStyle}
                    >
                      {option.name}
                    </label>
                    <label
                      className="d-none d-print-inline"
                      htmlFor={name}
                      style={optionsLabelStyle}
                    >
                      {option.name}
                    </label>
                  </span>
                ) : null}
              </div>
              {option.sub && <sub className="ms-2">{option.sub}</sub>}
            </React.Fragment>
          ))}
        </span>
        {error && <div className="mt-1 alert alert-danger">{error}</div>}
      </div>
    </>
  );
};

export default FormRadioButton;
